import {Map} from 'immutable';

function setState(state, newState) {
	/*console.log(state);
	console.log(newState);*/
  	return state.merge(newState);
}

const reducer = (state = Map(), action) => {
	switch (action.type) {
		case 'SET_STATE':
			return setState(state, action.state);
		default:
			return state;
	}
}
export default reducer;